import { guidFor } from "@ember/object/internals";
import Component from "@glimmer/component";

export interface S {
  Element: HTMLDivElement;
  Args: {
    onChange?: (event: Event) => void;
    onFocusOut?: (event: Event) => void;
    onFocusIn?: (event: Event) => void;
    dataTestInput?: string;
    propertyName?: string;
    labelName?: string;
    isMandatory?: boolean;
    moreInformation?: string;
    isReadOnly?: boolean;
    disabled?: boolean;
    value?: string | number | null;
    placeholder?: string;
    type?: string;
    min?: string;
    max?: string;
    step?: string;
    pattern?: string;
    formnovalidate?: string;
    autocomplete?: string;
  };
  Blocks: { default: [] };
}

export default class LabledInputComponent extends Component<S> {
  onChange = (event: InputEvent): void => {
    this.args.onChange?.(event);
  };

  onFocusOut = (event: FocusEvent): void => {
    this.args.onFocusOut?.(event);
  };

  onFocusIn = (event: FocusEvent): void => {
    this.args.onFocusIn?.(event);
  };

  get inputId(): string {
    return guidFor(this);
  }
}
